import { getConnectionForTenant } from 'config/tenantConnections';
import { HOME_ENVIRONMENT } from 'config/environments/homeEnvironments';
import { getCustomerSlugFromHostname } from './tenantUrl';

export type Auth0LoginParams = {
  connection?: string;
  // eslint-disable-next-line camelcase
  login_hint?: string;
};

export const getAuth0LoginParams = (
  search: string = window.location.search,
  hostname: string = window.location.hostname
): Auth0LoginParams => {
  const urlConnection = new URLSearchParams(search).get('connection');
  const loginHint = getCustomerSlugFromHostname(hostname);
  const mappedConnection = loginHint ? getConnectionForTenant(loginHint) : null;
  const connection =
    urlConnection ||
    mappedConnection ||
    (loginHint ? HOME_ENVIRONMENT.CONNECTION_NAME : null);

  return {
    ...(connection ? { connection } : {}),
    // eslint-disable-next-line camelcase
    ...(loginHint ? { login_hint: loginHint } : {})
  };
};
